import angular from 'angular';
import uiRouter from 'angular-ui-router';
import WorkerComponent from './worker.component';

let WorkerModule = angular.module('Worker', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newWorker', {
            url: '/workers/new',
            component: 'worker',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editWorker', {
            url: '/workers/:id',
            component: 'worker',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                worker: (
                    WorkersService,
                    $stateParams
                ) =>  WorkersService.findById($stateParams.id)
            }
        });
})
.component('worker', WorkerComponent)
.name;

export default WorkerModule;
